export enum PRODUCTION_STATUSES {
  ORDERED = "ORDERED",
  IN_STOCK = "IN_STOCK",
  DELIVERY = "DELIVERY",
}
